import { listado } from "./listado";
import { api } from "./backend";

export function crear() {
  return {
    modulo: crearModulo(),
    moduloContenido: crearModuloContenido(),
    imagenes: crearImagenes(),
    campanias: [],
  };
}

export function crearModulo() {
  return {
    id: null,
    tipo: 2,
    nombre: "",
    visibleEnTodasCampanias: true,
    permiteCambioPrecio: false,
    permiteCambioHoras: false,
    cubreCosteDeImplementacion: false,
    moduloRenovacion: false,
    precioModificado: false,
  };
}

export function crearModuloContenido() {
  return {
    descCorta: "",
    descLarga: "",
    logo: null,
    necesidad: "",
    solucion: "",
    rutaCaptura: null,
  };
}

export function crearImagenes() {
  return {
    logo: {},
    rutaCaptura: {},
  };
}

export function listar(params) {
  return listado("modulos/listar", params);
}

export async function cargar(id) {
  const response = await api.get("modulos/cargar&id=" + id);
  const modulo = response.data;

  normalizarModulo(modulo);

  return modulo;
}

export async function cargarCompleto(id) {
  const response = await api.get("modulos/cargarCompleto&id=" + id);
  const payload = response.data;

  normalizarModulo(payload.modulo);

  return payload;
}

export async function cargarContenido(id) {
  const response = await api.get("modulos/cargarContenido&id=" + id);
  return response.data;
}

export async function cargarPrecios(id) {
  const response = await api.get("modulos/cargarPrecios&id=" + id);
  return response.data;
}

export async function cargarHoras(id) {
  const response = await api.get("modulos/cargarHoras&id=" + id);
  return response.data;
}

export function insertar(modulo) {
  return api.post("modulos/insertar", {
    modulo: modulo.modulo,
    imagenes: modulo.imagenes,
    moduloContenido: modulo.moduloContenido,
    campanias: modulo.campanias,
  });
}

export function actualizar(modulo) {
  return api.post("modulos/actualizar", {
    modulo: modulo.modulo,
    imagenes: modulo.imagenes,
    moduloContenido: modulo.moduloContenido,
    campanias: modulo.campanias,
  });
}

export function guardarPreciosTarifa(moduloId, tarifaId, precios) {
  return api.post("modulos/guardarPreciosTarifa", { moduloId, tarifaId, precios });
}

export function actualizarHoras(id, moduloPlanHoras) {
  return api.post("modulos/actualizarHoras", { id, moduloPlanHoras });
}

export function eliminar(id) {
  return api.post("modulos/eliminar", { id });
}

export function normalizarModulo(data) {
  data.visibleEnTodasCampanias = Boolean(data.visibleEnTodasCampanias);
  data.permiteCambioPrecio = Boolean(data.permiteCambioPrecio);
  data.permiteCambioHoras = Boolean(data.permiteCambioHoras);
  data.cubreCosteDeImplementacion = Boolean(data.cubreCosteDeImplementacion);
  data.moduloRenovacion = Boolean(data.moduloRenovacion);
  data.precioModificado = Boolean(data.precioModificado);
  return data;
}
